import {
    FormControl,
    InputLabel,
    MenuItem,
    Select as SelectMUI,
} from "@mui/material";
import { Spinner } from "@nextui-org/react";

function Select({
    name,
    label,
    options,
    register,
    error,
    className,
    setValue,
    watch,
    isOptionsLoading = false,

    ...props
}) {
    const handleSelected = (event) => {
        setValue(name, event.target.value);
    };
    return (
        <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label" sx={{
                backgroundColor: '#f3f4f6',
                '&.Mui-focused': {
                    backgroundColor: '#f3f4f6'
                }
            }}>{label}</InputLabel>
            <SelectMUI
                labelId="demo-simple-select-label"
                id={name}
                error={error}
                className={className}
                value={watch?.(name) !== undefined ? watch?.(name) : ""}
                label={"label"}
                onChange={handleSelected}
                {...props}
                {...register}
            >

                {isOptionsLoading ? (
                    <MenuItem disabled sx={{ display: "flex", justifyContent: "center" }}>
                        <Spinner size="sm" />
                    </MenuItem>
                ) : (
                    options.map((option, index) => (
                        <MenuItem key={index} value={option.value}>
                            {option.text}
                        </MenuItem>
                    ))
                )}
            </SelectMUI>
            <p className="pt-0.5 text-sm text-red-600">{error}</p>
        </FormControl>
    );
}

export default Select;
